export type VolumePage = {
  src: string
  alt: string
  caption: string
}

/**
 * Páginas reales de DPS46 · Volume 4: Circles para el carrusel "Look inside"
 * (VolumeCarousel). Orden fijo: slide-01-p1 … slide-10-p48. 1080×1920 (9:16).
 */
export const volumePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/mFkFApWstsadNafPDSZaNr/slide-01-p1.png',
    alt: 'Volume 4 cover page: Breathwork Session Ready, Circles, with a line drawing of breathers lying on mats in a circle',
    caption: 'The cover: 23 Breath Cards, 6 worksheets, 3 frameworks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dmfxwEJE39PZNh8L9mM8PF/slide-02-p6.png',
    alt: 'The Circle Container page: a five-part wheel (Open, Agree, Breathe, Share, Seal) with a table of each step, its job and its cards',
    caption: 'The Circle Container: the five steps every circle follows',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/t6nwwizkD36imJguTgrUdg/slide-03-p9.png',
    alt: 'Room setup page: mat diagrams for a small circle, a large circle and facing rows, with a table of spacing, assistant and speaker positions',
    caption: 'Room setup for 6, 12 and 20 breathers, with spacing and assistant positions',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/j7wesARHscATAHfKDvLN7B/slide-04-p14.png',
    alt: 'Comparison page: a typical class in rows next to a held circle, with six side-by-side differences and a “Say it” line',
    caption: 'A room that feels held vs. a room that feels like a class',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/m2aXjYQmwMa534Kr5kJ2C7/slide-05-p4.png',
    alt: 'Timing formula page: minutes per step for 75, 90 and 120-minute circles, stacked timing bars and a music intensity scale',
    caption: 'Timing formula for 75, 90 and 120-minute circles',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sq19njesjKjECEocB9xWBj/slide-06-p17.png',
    alt: 'Breath Card BC-078 Full Moon Release Circle: a breath arc curve over 75 minutes, eight scripted steps, soften and deepen options and what to say',
    caption: 'Full Moon Release Circle: a complete Breath Card, ready to run',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9Us2teypfn2zxhXTSqsYLR/slide-07-p24.png',
    alt: 'Breath Card BC-085 The Beginner’s Circle: a ring of mats, Gentle dial setting, nine “Say it” lines and a common misstep with its fix',
    caption: 'The Beginner’s Circle: a first time in a group, made simple',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nqaPyG3XvAx2TkLwNn5qu3/slide-08-p13.png',
    alt: 'Worksheet WS-18 Circle Plan on a clipboard: fields for date, theme and assistants, and a table of steps, minutes, cards and music',
    caption: 'Circle Plan worksheet: plan any circle in 10 minutes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8ZGyr54ezbCG5hj82w6yz4/slide-09-p42.png',
    alt: 'Breath Card BC-096 The Closing Ritual: people standing in a circle, seven “Say it” lines and a “Land it” aftercare note',
    caption: 'The Closing Ritual: sealing the circle so everyone leaves steady',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oT6XMYr4vDi1ErcWYXRNej/slide-10-p48.png',
    alt: 'One circle, three paces: a table comparing Gentle, Steady and Full for breath, music peak, cues, sound and group rest',
    caption: 'One circle, three paces: Gentle, Steady and Full',
  },
]
